import * as React from 'react';

import { CheckboxField } from '@cian/components';
import { DropdownField } from '../../../components/dropdownField';

import { EWindowsType } from '../../../../../../../json_query';
import { InlineParam } from '../../../markup';

interface IWindowsProps {
  windows: EWindowsType;
  withBalconies: boolean;
  onWindowsChange(value: EWindowsType): void;
  onBalconiesChange(value: boolean): void;
}

type valueType = 'Courtyard' | 'Street' | 'Any';

export const getValue = (windows: EWindowsType): valueType => {
  if (windows === EWindowsType.Courtyard) {
    return 'Courtyard';
  }
  if (windows === EWindowsType.Street) {
    return 'Street';
  }

  return 'Any';
};

export class Windows extends React.Component<IWindowsProps> {
  public render() {
    return (
      <>
        <InlineParam>
          <DropdownField
            value={getValue(this.props.windows)}
            onValueChange={this.handleChange}
            values={[
              { value: 'Any', label: 'Неважно' },
              { value: 'Courtyard', label: 'Во двор' },
              { value: 'Street', label: 'На улицу' },
            ]}
          />
        </InlineParam>
        <InlineParam>
          <CheckboxField
            onValueChange={this.props.onBalconiesChange}
            value={this.props.withBalconies}
            label="Балкон / Лоджия"
          />
        </InlineParam>
      </>
    );
  }

  private handleChange = (value: string) => {
    const { onWindowsChange } = this.props;
    let resultValue = EWindowsType.Any;

    if (value === 'Courtyard') {
      resultValue = EWindowsType.Courtyard;
    } else if (value === 'Street') {
      resultValue = EWindowsType.Street;
    }
    onWindowsChange(resultValue);
  };
}
